export default __webpack_public_path__ + "static/media/award-3.68a57fb3.png";